<template>
  <b-tabs
    vertical
    content-class="col-12 col-md-9 mt-1 mt-md-0"
    pills
    nav-wrapper-class="col-md-3 col-12"
    nav-class="nav-left"
  >
    <!-- general tab -->
    <b-tab active>
      <!-- title -->
      <template #title>
        <feather-icon icon="UserIcon" size="18" class="mr-50" />
        <span class="font-weight-bold">Génerale</span>
      </template>

      <account-setting-general
        v-if="options.general"
        :general-data="options.general"
      />
    </b-tab>
    <!--/ general tab -->

    <!-- change password tab -->
    <b-tab>
      <!-- title -->
      <template #title>
        <feather-icon icon="LockIcon" size="18" class="mr-50" />
        <span class="font-weight-bold">Changer Mot de passe</span>
      </template>

      <account-setting-password />
    </b-tab>
    <!--/ change password tab -->

    <!-- info -->
    <b-tab>
      <!-- title -->
      <template #title>
        <feather-icon icon="InfoIcon" size="18" class="mr-50" />
        <span class="font-weight-bold">Informations sur la société</span>
      </template>

      <account-setting-information
        v-if="options.info"
        :information-data="options.info"
      />
    </b-tab>

    <b-tab>
      <!-- title -->
      <template #title>
        <feather-icon icon="DollarSignIcon" size="18" class="mr-50" />
        <span class="font-weight-bold">Informations du paiement</span>
      </template>

      <account-setting-payment
        v-if="options.info"
        :information-data="options.info"
      />
    </b-tab>

  </b-tabs>
</template>

<script>
import { BTabs, BTab } from "bootstrap-vue";
import AccountSettingGeneral from "./AccountSettingGeneral.vue";
import AccountSettingPassword from "./AccountSettingPassword.vue";
import AccountSettingInformation from "./AccountSettingInformation.vue";
import AccountSettingPayment from "./AccountSettingPayment.vue";

import axios from "axios";

export default {
  components: {
    BTabs,
    BTab,
    AccountSettingPayment,
    AccountSettingGeneral,
    AccountSettingPassword,
    AccountSettingInformation,
  },
  data() {
    return {
      options: {},
    };
  },
  async beforeCreate() {
    const res = await axios.get(
      `https://management-projects.herokuapp.com/api/users?id=${
        JSON.parse(localStorage.getItem("userData"))._id
      }`
    );

    this.options = {
      general: {
        firstName: res.data.firstName,
        lastName: res.data.lastName,
        email: res.data.email,
        image: `https://res.cloudinary.com/dmdd546ps/image/upload/v1615691410/${res.data.image}`,
        // image:
        //   res.data.image != null
        //     ? `https://res.cloudinary.com/dmdd546ps/image/upload/v1615691410/${res.data.image}`
        //     : "https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fstatic.vecteezy.com%2Fsystem%2Fresources%2Fpreviews%2F000%2F439%2F863%2Foriginal%2Fvector-users-icon.jpg&f=1&nofb=1",
      },
      info: {
        paymentTerms: res.data.paymentTerms,
        companyEmail: res.data.companyEmail,
        companyFax: res.data.companyFax,
        companyTel: res.data.companyTel,
        currency: res.data.currency,
        taxRegistrationNumber: res.data.taxRegistrationNumber,
        paymentType: res.data.paymentType,
        country: res.data.country,
        postalCode: res.data.postalCode,
        address: res.data.address,
        company: res.data.company,
        signature: res.data.signature
      },
    };
    console.log(this.options);
  },
};
</script>
